import Loader from "react-loader-spinner";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { getDefinedServices } from "../store/api/TaskDetailsApi";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import DatePicker from "react-datepicker2";
import BihamtaTable from "../../Components/BihamtaTable";
import { getDefinedServiceCostAggregate } from "../store/api/Services";
import BihamtaMultiSelect from "../../Components/BihamtaMultiSelect";
import { FileEarmarkBarGraph, FileEarmarkExcelFill, PrinterFill } from "react-bootstrap-icons";
import { exportToExcel, isWebApp } from "../../store/api/CommonFunctions";

const DefinedServiceCostAggregateReport = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { filterData, settings, defineds } = useSelector(state => { return { filterData: state.service.defServCostsAggFilters, settings: state.SystemSettingsReducer.systemSettings, defineds: state.taskDetails.definedServiceList } });
    const { register, handleSubmit } = useForm();
    const [dateFilters, setDateFilters] = useState({});
    const [pending, setPending] = useState(false);
    const selectedDefs = useRef([]);
    const settingNames = ['ProductGrouppingType'];
    const pgType = Array.isArray(settings) && settings.find(s => s.SettingName === "ProductGrouppingType") ?
        Number(settings.find(s => s.SettingName === "ProductGrouppingType").SettingValue) : 1;
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف", justInMobile: true },
        { colName: "DefinedCode", colTitle: "کد تعرفه", justInMobile: true },
        { colName: "DefinedDescription", colTitle: "شرح تعرفه", justInMobile: true },
        { colName: "DefinedCount", colTitle: "تعداد کل" },
        { colName: "DefinedTotalPrice", colTitle: "جمع کل", colType: "currency" },
        { colName: "DefinedDiscount", colTitle: "جمع تخفیف", colType: "currency" },
        { colName: "TaxAmount", colTitle: "جمع مالیات", colType: "currency" },
        { colName: "PureTotalPrice", colTitle: "جمع خالص", colType: "currency" },
        { colName: "DefinedStaffShare", colTitle: "سهم تکنسین", colType: "currency" }
    ]
    function addRemoveDef(item) {
        const splited = item.value.split(",");
        if (item.checked) {
            if (!selectedDefs.current.includes(splited)) {

                selectedDefs.current.push(...splited);
            }
        }
        else {
            selectedDefs.current = selectedDefs.current.filter(a => !splited.includes(a));
        }
        // if (add) {
        //     if (!currentRole.current.includes(id))
        //         currentRole.current.push(id);
        // }
        // else {
        //     currentRole.current = currentRole.current.filter(r => r !== id);
        // }
    }
    function toExcel() {
        const url = `api/ServiceReportsAPI/GetDefinedServiceCostAggregate`;
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        searchArgs.Skip = 0;
        setPending(true);
        exportToExcel("DefinedServiceCostAggregate", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function printReport(e) {
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        searchArgs.Skip = 0;
        history.push({
            pathname: `/PrintViewer/DefinedServiceCostAggregate/${e.ctrlKey}`,
            state: {
                dataUrl: `api/ServiceReportsAPI/GetDefinedServiceCostAggregate`,
                method: "post",
                fetchBody: JSON.stringify(searchArgs)
            }
        });
    }
    function search(data) {
        const dateFrom = document.getElementsByName("DateFrom")[0].value;
        if (dateFrom !== "") {
            data.ContactDateFrom = dateFilters.DateFrom;
            data.PDateFrom = dateFrom;
        }
        const dateTo = document.getElementsByName("DateTo")[0].value;
        if (dateTo !== "") {
            data.ContactDateTo = dateFilters.DateTo;
            data.PDateTo = dateTo;
        }
        const staffSendDateFrom = document.getElementsByName("StaffSendDateFrom")[0].value;
        if (staffSendDateFrom !== "") {
            data.StaffSendDateFrom = dateFilters.StaffSendDateFrom;
            data.PStaffSendDateFrom = staffSendDateFrom;
        }
        const staffSendDateTo = document.getElementsByName("StaffSendDateTo")[0].value;
        if (staffSendDateTo !== "") {
            data.StaffSendDateTo = dateFilters.StaffSendDateTo;
            data.PStaffSendDateTo = staffSendDateTo;
        }  
        const lastRefDateFrom = document.getElementsByName("LastRefDateFrom")[0].value;
        if (lastRefDateFrom !== "") {
            data.LastRefDateFrom = dateFilters.LastRefDateFrom;
            data.PLastRefDateFrom = lastRefDateFrom;
        }
        const lastRefDateTo = document.getElementsByName("LastRefDateTo")[0].value;
        if (lastRefDateTo !== "") {
            data.LastRefDateTo = dateFilters.LastRefDateTo;
            data.PLastRefDateTo = lastRefDateTo;
        }              
        data.Skip = 0;
        data.DefinedIDs = selectedDefs.current;
        dispatch(getDefinedServiceCostAggregate(data));

    }
    function showDetailed(item) {
        if (item.ctrlIsDown) {
            window.open(`/Services/DefinedServiceCostDetail/${item.DefinedServiceID}`);
        }
        else {
            history.push(`/Services/DefinedServiceCostDetail/${item.DefinedServiceID}`);
        }
    }
    useEffect(() => {
        dispatch(getSystemSettings(settingNames));
        document.body.classList = "notMain";
        dispatch(getDefinedServices("", 0));
    }, [])
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card>
            </Card>
            <Card.Header className="headerStyle">
                گزارش تجمیعی خدمات و تعرفه ها
            </Card.Header>
            <Card.Body className="bodyStyle">
                <form onSubmit={handleSubmit(search)}>
                    <Row className="rowBorder">
                        <Col md={2} className="form-group">
                            <label>نوع سرویس: </label>
                            <Form.Control as="select" name="ServiceType" ref={register({})}>
                                <option value="">انتخاب کنید</option>
                                <option value="install">نصب</option>
                                <option value="repair">تعمیر</option>
                            </Form.Control>
                        </Col>
                        <Col md={2} className="form-group">
                            <label>تاریخ پذیرش از: </label>
                            <DatePicker className="form-control" timePicker={false} isGregorian={false} name="DateFrom" onChange={val => dateFilters.DateFrom = val.local("en").format("YYYY-MM-DD")} />
                        </Col>
                        <Col md={2} className="form-group">
                            <label>تاریخ پذیرش تا: </label>
                            <DatePicker className="form-control" timePicker={false} isGregorian={false} name="DateTo" onChange={val => dateFilters.DateTo = val.local("en").format("YYYY-MM-DD")} />
                        </Col>
                        <Col md={2} className="form-group">
                            <label>تاریخ اعزام از: </label>
                            <DatePicker className="form-control" timePicker={false} isGregorian={false} name="StaffSendDateFrom" onChange={val => dateFilters.StaffSendDateFrom = val.local("en").format("YYYY-MM-DD")} />
                        </Col>
                        <Col md={2} className="form-group">
                            <label>تاریخ اعزام تا: </label>
                            <DatePicker className="form-control" timePicker={false} isGregorian={false} name="StaffSendDateTo" onChange={val => dateFilters.StaffSendDateTo = val.local("en").format("YYYY-MM-DD")} />
                        </Col>
                        <Col md={2} className="form-group">
                            <label>تاریخ انجام از: </label>
                            <DatePicker className="form-control" timePicker={false} isGregorian={false} name="LastRefDateFrom" onChange={val => dateFilters.LastRefDateFrom = val.local("en").format("YYYY-MM-DD")} />
                        </Col>
                        <Col md={2} className="form-group">
                            <label>تاریخ انجام تا: </label>
                            <DatePicker className="form-control" timePicker={false} isGregorian={false} name="LastRefDateTo" onChange={val => dateFilters.LastRefDateTo = val.local("en").format("YYYY-MM-DD")} />
                        </Col>                                                  
                        <Col md={2} className="form-group">
                            <label>نام تکنسین: </label>
                            <Form.Control name="StaffName" ref={register({})} />
                        </Col>
                        <Col className="form-group col-md-2">
                            <label>فهرست تعرفه ها</label>
                            <BihamtaMultiSelect dataSource={defineds} valueItem="ID" displayItem="Description" onItemCheckChanged={addRemoveDef} defaultCheckedList={selectedDefs.current} />
                        </Col>
                    </Row>
                    <Button className="group-Btn-large" type="submit"><FileEarmarkBarGraph size={18} />&nbsp;خروجی گزارش</Button>
                </form>
                {!pending &&
                    <div style={{ padding: 1, width: "100%", textAlign: "left", marginTop: "5px" }}>
                        <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                        <PrinterFill color="blue" size={25} style={{ cursor: "pointer" }} className="hoverIcon" onClick={printReport} />
                    </div>}
                {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                <BihamtaTable columns={tableCols} reducerName="service" objectName="defServCostsAgg" searchMethod={(data) => dispatch(getDefinedServiceCostAggregate(data))} fixedHeight className="mt-0 mb-0"
                    style={{ whiteSpace: "nowrap" }} rowClick={showDetailed} />
                    {isWebApp() &&
                    <div style={{textAlign:"left", color:"blue"}}>
                        برای دیدن جزئیات گزارش روی ردیف مورد نظر کلیک کنید 
                        </div>}
            </Card.Body>
        </div>
    )
}
export default DefinedServiceCostAggregateReport;